import React from 'react';
import { BlockedMarker } from '../../icons';

/**
 * Single blocked mission with warning icon.
 */
const BlockedMissionItem = ({ task, onGoToTask, onMouseEnter, onMouseLeave }) => (
  <div
    className="flowchart-hud__mission-item flowchart-hud__mission-item--blocked"
    onClick={() => onGoToTask?.(task.id)}
    title={task.blockedReason || 'Blocked'}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <span className="flowchart-hud__mission-marker">
      <BlockedMarker size={16} className="flowchart-hud__blocked-icon--small" />
    </span>
    <span className="flowchart-hud__mission-name">
      {task.name}
    </span>
  </div>
);

export default BlockedMissionItem;
